module.exports = __webpack_public_path__ + "img/renzhengshibai.59b0195d.png";